import { Component, OnInit, Input , ViewChild} from '@angular/core';
import { DxSelectBoxModule, DxTemplateModule } from 'devextreme-angular';
//import {ParentComponentApi,AdmissionformComponent} from "../admissionform.component";
import {ChecklistformComponent} from "../checklistform/checklistform.component";
import {Router, ActivatedRoute,NavigationExtras }  from '@angular/router'; 
import {CourseselectionService,EntPreStudentCollegeList,
  PreStudentOtherInfo,CourseType,PreProspectTrClass,ScheuldeData} from "../../../services/courseselection.service";
import { Configuration } from '../../../../app.constants';
import{DirectadmissionComponent}from'./../directadmission/directadmission.component';
import {HelperService} from '../../../../shared/services/helper.service';
import {Tab, AdmissionService,directadmission} from "../../../services/admission.service";
import {CourseService,Course} from '../../../services/course.service';
import { DxDataGridModule } from "devextreme-angular";
import {CetadmissionService,CETadmission} from '../../../services/cetadmission.service';
import { forEach } from '@angular/router/src/utils/collection';
import { DxPopupComponent } from 'devextreme-angular';
import "devextreme/ui/html_editor/converters/markdown";
import {DashboardComponent} from '../../dashboard/dashboard.component';
import { SystemmenuService, SystemModule } from '../../../../shared/services/systemmenu.service';
import { AuthService } from '../../../../shared/services/auth.service';

@Component({
  selector: 'courseselectionprospectus',
  templateUrl: './courseselectionprospectus.component.html',
  styleUrls: ['./courseselectionprospectus.component.scss']
})
export class CourseselectionprospectusComponent implements OnInit {
  @ViewChild("dxPopUpVar") dxPopup: DxPopupComponent;
  data:EntPreStudentCollegeList;
  dataSource:any;
  tempData:any;
  predata:any;
  alreadypresentdata:any;
  strApply :string="";
  status:boolean=false;

  griddata:any;
  Maingriddata:any;
  coursetypeData:any;
  CollegeID:number;
  MediumFilter:any;
  LanguageLabel:any;
  CourseTypeID:number;
  ProspectusData:any;
  ProspectusDataCheck:any;
  paymentmsg:string="";
  paysource:any;
  paymentdis:boolean=false;
  isExpired:boolean;
  CurrentData:any;
  private sub: any;
  TotalProspectFees:number;
  errorMessage: string[] = new Array(); 
  CourseID:number;
  documentId:number;
  urlDoc:string;
  popupTitle:string;
  popupVisible: boolean;
  htmlcontent:string;
  instructionlist:any;
  submodulelist:any;

  popupTitleInst:string;
  popupVisibleInst: boolean;
  formname:string;

  List1: any;
  menuItems: any[] = [];
  private _compactMode = false;
  menuId: number;
  submenupath:string;
  ProspectRecieptPrint:string;

  prospectdata:any;
  @Input() parentApi: ParentComponentApi;
  @Input() index:any;
  @Input() isON:any;
  printrecdis:boolean=true;
  showpaymentbtn:boolean=true;
  showreceiptbtn:boolean=true;
  prospectshow:number;

  constructor(private router: Router,private CourseService:CourseService, private CourseselectionService : CourseselectionService,private Configuration:Configuration,private HelperService: HelperService,
    private AdmissionService:AdmissionService,private cetService:CetadmissionService,
    private route: ActivatedRoute,public DashboardComponent:DashboardComponent,
    private systemMenuService:SystemmenuService,
    private AuthService:AuthService) {
    this.applyClicked = this.applyClicked.bind(this);
  }
  nextTab(i){

      this.parentApi.callParentMethod('1',i);
  }
  backTab(i){

      this.parentApi.callParentMethod('2',i);
  }
  onValueChangedCourseType(e){
    this.CourseTypeID=e.value;
    this.Maingriddata=[];
    this.FindRecord();
  }  
  paymentdone(){
    this.paymentdis=false;
  }
  calculateSelectedRow(options) {
    debugger;
    if (options.name === "SelectedRowsSummary") {
        if (options.summaryProcess === "start") {
                options.totalValue = 0;
            } else if (options.summaryProcess === "calculate") {
                if (options.component.isRowSelected(options.value.ProspectusID)) {
                  options.totalValue = options.totalValue + options.value.CourseProspectusAmount
                  /* let  TotalProspectFees=0;
                  if(this.Maingriddata !=undefined){
                    for (var i = 0; i < this.Maingriddata.length; i++) {
                      if (this.Maingriddata[i].chk == true) {
                        TotalProspectFees=TotalProspectFees+ parseInt(this.Maingriddata[i].CourseProspectusAmount);
                      }
                    }
                  }
                  this.TotalProspectFees = TotalProspectFees; */
                }
            }
    }
  } 
  popupHiding(e) {
    this.errorMessage = [];
  };
  popupHidingInst(e) {
    this.errorMessage = [];
  };
  viewPdfDocument(e) {
    debugger;
    if (e.row.data.FilePathCourseProspectus.length > 0) {
      this.documentId = e.row.data.ProspectusID;
      this.urlDoc = e.row.data.FilePathCourseProspectus ;
      this.openWindow();
    }
  }
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  FindRecord(){
    this.Maingriddata=[];
    debugger;
    if(this.CourseTypeID ==null || this.CourseTypeID ==undefined){
      return;
    }
    this.CourseselectionService.GetCourseDetailsForProspectus(this.CourseTypeID,this.Configuration.StuPoartlaID,this.Configuration.AcademicInstanceID,this.Configuration.CollegeID)
        .subscribe((data: PreProspectTrClass[]) => this.ProspectusData = data,
          error => {
            alert(error);
          },
          () => {
            
            this.TotalProspectFees =0;
            for (var i = 0; i < this.ProspectusData.length; i++) {
              if (this.ProspectusData[i].PaymentFlag == "Y") {
                this.ProspectusData[i].chk == true;
                this.ProspectusData[i].checkdisable == true;
              }else{
                this.ProspectusData[i].chk == false;
                this.ProspectusData[i].checkdisable == false;
              }
              if (this.Configuration.ProspectPurchaseFlag == "Y" && this.ProspectusData[i].PaymentFlag == "N") {
                this.ProspectusData[i].FilePathCourseProspectus = "";
              }
            }
            
            this.Maingriddata = this.ProspectusData;
            
            this.CourseselectionService. GetCollegeProspectPaymentReceipt(this.Configuration.StuPoartlaID,this.Configuration.AcademicInstanceID,this.Configuration.CollegeID,"O")
          .subscribe((data: PreProspectTrClass[]) => this.tempData = data,
            error => {
              alert(error);
            },
            () => {
              this.ProspectRecieptPrint=this.tempData.Message;
              
              if(this.ProspectRecieptPrint==null ||   this.ProspectRecieptPrint==="" ||   this.ProspectRecieptPrint===undefined){
                this.printrecdis=true;
              }else{
                this.printrecdis=false;
              }
            }); 
        }); 
  } 
  ViewInstructionPopup(){
    this.popupVisibleInst = true;
    this.popupTitleInst="Instructions";
    this.formname="courseselectionprospectus";
  }
  getSystemMenu() {
    this.systemMenuService.GetUserGroupIDforPortal()
    .subscribe((data:SystemModule[]) => this.List1 = data,
    error => {
    alert(error);
      },
      () => {
        if(this.List1.length>0){
          this.Configuration.SysUsrGrpID=this.List1[0].SysUsrGrpID;
         
            this.menuId = 0;
            this.systemMenuService.getAllMenuByGroupId(this.Configuration.SysUsrGrpID,'En').subscribe(
              (data: SystemModule[]) => {
      
                for (var i = 0; i < data.length; i++) {
      
                  var module = {
                    id: 0,
                    text: '',
                    path: '',
                    icon: '',
                    items: []
                  }
                  this.menuId = this.menuId + 1;
                var sysModueData = data[i];
                    module.icon = '';
                  module.path = "/";
                  module.text = sysModueData.SysModName;
                  module.id = this.menuId; 
                  if ((sysModueData.SysSubModList)) {
      
                    for (var p = 0; p < sysModueData.SysSubModList.length; p++) {
                      var item = {
                        id: 0,
                        text: '',
                        path: '',
                        icon: '',
                        items: [],
                        SysSubModID:0,
                        Instruction:'',
                        InStructionInDevnagri:'',
                      }
      
                      this.menuId = this.menuId + 1;
                      var programModule = sysModueData.SysSubModList[p];
                      item.icon = programModule.SubModuleImageClass,
                      item.path = programModule.SysSubModShrtName;
                      item.text = programModule.SysSubModName;
                      item.id = this.menuId; 
                      item.SysSubModID=programModule.SysSubModID;//programModule.SysSubModID;
                      if ((programModule.SysProgList) && (programModule.SysProgList.length > 0)) {
                        for (var x = 0; x < programModule.SysProgList.length; x++) {
                          var programItem = {
                            id: 0,
                            text: '',
                            path: '',
                            icon: '',
                            AccessPath:'',
                            SysSubModID:0,
                            Instruction:'',
                            InStructionInDevnagri:'',
                          }
                          this.menuId = this.menuId + 1;
                          var systemProgram = programModule.SysProgList[x];
                         
                          programItem.path = "/"+ item.path+"/"+systemProgram.GridFormToOpen;
                          programItem.text = systemProgram.SysProgName;
                          programItem.id = this.menuId;
                          programItem.AccessPath=systemProgram.GridFormToOpen;
                          programItem.icon=systemProgram.PrgImgClass// systemProgram.SysProgID;
                          programItem.SysSubModID=0;
                          programItem.Instruction=systemProgram.Instruction;
                          programItem.InStructionInDevnagri=systemProgram.InStructionInDevnagri;
                          item.items.push(programItem);
                        }
                      }
                      module.items.push(item);
                    }
                    this.Configuration.progoramlist = module.items;

                  }
                }
               /*  for (var i = 0; i < this.Configuration.progoramlist.length; i++) {
                  if(this.Configuration.progoramlist[i].AccessPath=="courseselectionprospectus"){
                    if(this.Configuration.SelectedLanguage=="En" && this.Configuration.progoramlist[i].InStructionInDevnagri=="") {
                      this.htmlcontent=this.Configuration.progoramlist[i].Instruction;
                    }else if(this.Configuration.SelectedLanguage!="En" && this.Configuration.progoramlist[i].InStructionInDevnagri!="") { 
                      this.htmlcontent=this.Configuration.progoramlist[i].InStructionInDevnagri;
                    }else{
                      this.htmlcontent=this.Configuration.progoramlist[i].Instruction;
                    }
                  }
                } */
                debugger;
                for (var i = 0; i < this.Configuration.progoramlist.length; i++) {
                  if(this.Configuration.progoramlist[i].text =="Dashboard"){
                    for (var j = 0; j < this.Configuration.progoramlist[i].items.length; j++) {
                      if(this.Configuration.progoramlist[i].items[j].AccessPath=="courseselectionprospectus"){
                        if(this.Configuration.SelectedLanguage=="En" && this.Configuration.progoramlist[i].items[j].InStructionInDevnagri=="") {
                          this.htmlcontent=this.Configuration.progoramlist[i].items[j].Instruction;
                        }else if(this.Configuration.SelectedLanguage!="En" && this.Configuration.progoramlist[i].items[j].InStructionInDevnagri!="") { 
                          this.htmlcontent=this.Configuration.progoramlist[i].items[j].InStructionInDevnagri;
                        }else{
                          this.htmlcontent=this.Configuration.progoramlist[i].items[j].Instruction;
                        }
                      }
                    }
                  }
                }
              },
              error => {
                alert(error);
              },
              () => {
              });
        }
      }); 
  }
  ngOnInit() {
    debugger

    this.Configuration.FromProspect=true;

    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    if(this.Configuration.ProspectPurchaseFlag =="N"){
        this.showpaymentbtn=false;
        this.showreceiptbtn=false;
    }else{
      this.showpaymentbtn=true;
      this.TotalProspectFees=0;
      this.showreceiptbtn=true;
    }
    this.CourseselectionService.GetCheckPurchaseProspectus(this.Configuration.StuPoartlaID,this.Configuration.AcademicInstanceID,this.Configuration.CollegeID)
    .subscribe((data: PreProspectTrClass[]) => this.ProspectusDataCheck = data,
      error => {
        alert(error);
      },
      () => {
          debugger
          this.CourseselectionService. GetCollegeProspectPaymentReceipt(this.Configuration.StuPoartlaID,this.Configuration.AcademicInstanceID,this.Configuration.CollegeID,"O")
          .subscribe((data: PreProspectTrClass[]) => this.tempData = data,
            error => {
              alert(error);
            },
            () => {
              this.ProspectRecieptPrint=this.tempData.Message;
              if(  this.ProspectRecieptPrint==null ||   this.ProspectRecieptPrint==="" ||   this.ProspectRecieptPrint===undefined){
                this.printrecdis=true;
              }else{
                this.printrecdis=false;
              }
              this.CourseselectionService.GetBasicCourseTypeList()
              .subscribe((data: CourseType[]) => this.coursetypeData = data,
                error => {
                  alert(error);
                },
                () => {
                  this.getSystemMenu();
                  this.CourseTypeID=0;
                  //this.FindRecord();
                }); 
            }); 
     }); 
  }
  oncheckchange(){
    let  TotalProspectFees=0;
    if(this.Maingriddata !=undefined){
      for (var i = 0; i < this.Maingriddata.length; i++) {
        if (this.Maingriddata[i].chk == true) {
          TotalProspectFees=TotalProspectFees+ parseInt(this.Maingriddata[i].CourseProspectusAmount);
        }
      }
    }
    if(this.Configuration.ProspectPurchaseFlag =="Y"){
      this.TotalProspectFees = TotalProspectFees;
    }else{
      this.TotalProspectFees = 0;
    }
    
  }
  afterpaymentclick(){
    this.CourseselectionService.GetCheckPurchaseProspectus(this.Configuration.StuPoartlaID,this.Configuration.AcademicInstanceID,this.Configuration.CollegeID)
    .subscribe((data: PreProspectTrClass[]) => this.ProspectusDataCheck = data,
      error => {
        alert(error);
        
      },
      () => {
          this.FindRecord();
      
      }); 
  }
  cancelClick() {
    debugger;
    if(this.ProspectusDataCheck.length>0){
      this.DashboardComponent.popupVisibleProspect=false;
      this.Configuration.loggedstatus="Y";
      this.router.navigate(['studentportal/dashboard']);
    }
    else if(this.Configuration.ProspectFlag =="Y" && this.Configuration.ProspectPurchaseFlag =="Y"){ 
      this.HelperService.showWarningMessage("You have not purchase any prospect, please purchase then go to profile.");
    } else if(this.prospectshow == 0) {
      this.HelperService.showWarningMessage("You have not purchase any prospect, please purchase then go to profile.");
    } else {
      this.DashboardComponent.popupVisibleProspect=false;
      this.Configuration.loggedstatus="Y";
      this.router.navigate(['studentportal/dashboard']);
    }
  }
  GoLoginClick(){
    debugger;
    this.AuthService.logOut();
  }
 values='';
 Applyclick(e){
  this.CurrentData = Object.assign({}, e.row.data);
  let navigationExtras: NavigationExtras = {
    queryParams: {
       "CourseID" : this.CurrentData.CourseID,
       "CourseName" : this.CurrentData.CourseName,
       "CourseProspectusAmount":this.CurrentData.CourseProspectusAmount,
       "CourseTypeID" : this.CourseTypeID
      }
    }
    this.router.navigate(['studentportal/prospectpayment'],navigationExtras);
 }
 applyClicked1(e) {
  debugger;
  var component = e.component;
  window.open(e.row.data.FilePathCourseProspectus,'_blank');
} 
 GetPaymentTrxNo()
  {
        this.paymentdis =true;
        this.CourseID  =this.Maingriddata[0].CourseID;
        this.cetService.getPaymentTrxNoForProspect(0,0, 0,0, this.Configuration.AcademicInstanceID,  this.Configuration.ExamInstanceID, this.Configuration.PurposeCodeProspect, this.TotalProspectFees, 0,this.Configuration.CollegeID,this.Configuration.StuPoartlaID)
        .subscribe((data: CETadmission[]) => this.dataSource = data,
        error => {
          alert(error);
        },
        () => {
          debugger
          if (this.dataSource[0].merchantTxnNo !=undefined || this.dataSource[0].merchantTxnNo != null)
          {
            this.Maingriddata.customerName = this.dataSource[0].customerName;
            this.Maingriddata.customerEmailId = this.dataSource[0].customerEmailId;
            this.Maingriddata.customerMobileNo = this.dataSource[0].customerMobileNo; 
            this.Maingriddata.customerID = this.dataSource[0].OnlinePaymentID;                       
            this.Maingriddata.merchantTxnNo = this.dataSource[0].merchantTxnNo;
            this.openWindowWithPostRequest();
          }
        });
  }
 openWindowWithPostRequest() { 
   debugger;
  var winName = 'MyWindow';
  var winURL = this.Configuration.PaymentAPIURL;
  var windowoption = 'resizable=yes,height=600,width=800,location=0,menubar=0,scrollbars=1';    
  var params = { 'StudentID': 0, 'CourseID':  0 , 
  'BranchID': 0, 'AcadamicInstanceID': this.Configuration.AcademicInstanceID, 
  'PurposeCode': this.Configuration.PurposeCodeProspect,'FeesAmount': this.TotalProspectFees,
  'merchantTxnNo': this.Maingriddata.merchantTxnNo, 'customerName': this.Maingriddata.customerName,
  'customerEmailId': this.Maingriddata.customerEmailId, 'customerMobileNo': this.Maingriddata.customerMobileNo,
  'customerID': this.Maingriddata.customerID, };
  var form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", winURL);
  form.setAttribute("target", winName);
  for (var i in params) {
      if (params.hasOwnProperty(i)) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = i;
          input.value = params[i];
          form.appendChild(input);
      }
  }
  document.body.appendChild(form);
  window.open('', winName, windowoption);
  form.target = winName;
  form.submit();
  document.body.removeChild(form);
  this.onSubmit();
}
timeLeft: number = 50;
interval;
onSubmit() {
  this.paymentmsg="Your Payment Transaction in Process please wait...";
  this.interval = setInterval(() => {
    if(this.timeLeft > 0) {
      this.timeLeft --;
      this.cetService.GetPaymentTranDetails( this.Maingriddata.merchantTxnNo) 
      .subscribe((data:CETadmission[]) => this.paysource = data,
      error => {
      alert(error);
        },
        () => {
                if(this.paysource.length ==0){
                  this.paymentdis =false;
                  this.isExpired =true;
                  return;
                }
                if (this.paysource[0].responseCode != undefined || this.paysource[0].responseCode != null)
                {
                    if(this.paysource[0].OnlinePaymentConfirmFlag =="Y")
                    {           
                        let PaymentType='O';
                        let PaymentFlag ='Y';
                        let Narration='Prospect Payment';
                        this.CurrentData =[];
                        if(this.Maingriddata !=undefined){
                          for (var i = 0; i < this.Maingriddata.length; i++) {
                            if (this.Maingriddata[i].chk == true) {
                              this.tempData =[];
                              this.tempData = this.Maingriddata[i];
                              this.tempData.StuPoartlaID =  this.Configuration.StuPoartlaID;
                              this.tempData.CollegeID =  this.Configuration.CollegeID;
                              this.tempData.AcademicInstanceID =  this.Configuration.AcademicInstanceID;
                              this.tempData.OnLinePaymentTransactionID =  this.Maingriddata.merchantTxnNo;
                              this.tempData.PurposeID = this.Configuration.PurposeCodeProspect;
                              this.CurrentData.push(this.tempData);
                            }
                          } 
                        }
                        this.CourseselectionService.PostInsertPreProspectTr(this.CurrentData)
                        .subscribe(value => {
                              this.paymentdis =false;
                              this.printrecdis=false;
                              this.errorMessage=[];
                              this.CurrentData =[];  
                              this.HelperService.showSuccessMessage("Your Payment Transaction is successfull, your Transcation Number is " + this.paysource[0].merchantTxnNo + ", Now you can download prospect & then Apply for course.");  
                              this.afterpaymentclick();
                          },
                          err => {
                            this.errorMessage=this.HelperService.getErrorMessage(err);
                            this.HelperService.showSuccessMessage("Not Saved In Prospect trn.");  
                            this.errorMessage=[];
                            this.CurrentData =[];  
                          },
                          () => {
                        });
                    }
                    else
                    {
                      this.CurrentData.CourseProspectusAmount=this.paysource[0].amount;
                      this.CurrentData.paymentdis =false;
                      this.CurrentData.isExpired =true;
                      this.HelperService.showWarningMessage("Your Payment Transaction is failure, your Transcation Number is " + this.paysource[0].merchantTxnNo  + " try again...");
                      this.FindRecord()
                    }
                    this.pauseTimer();
              }
              else
              {
                this.paymentmsg="Your Payment Transaction in Process...";
              }
        });  
    } else {
      this.pauseTimer();
      this.paymentmsg="Transaction is time out please try again...";
    }
  },10000)
}
pauseTimer() {
  clearInterval(this.interval);
}
 applyClicked(e) {
    debugger;
    var component = e.component;
    this.data = Object.assign({}, e.row.data);
    this.values='Direct Admission With Allotment Letter';
    let navigationExtras: NavigationExtras = {
      queryParams: {
         "courseid" : this.data.CourseID,
         "coursenm" : this.data.CourseName,
         "branchid" :this.data.BranchID,
         "branchnm":this.data.BranchName,
          "AdmCatID":this.data.AdmCatID,
          "StudentCourseID":this.data.StudentCourseID
           }
      }
      if(this.data.StudentCourseID != 0 && this.data.AdmCatID==2 && this.data.PaymentFlag =="Y" ){
            this.HelperService.showWarningMessage("You have already Applied for this Course.");
            return
        }            
       else if(this.data.StudentCourseID != 0 && this.data.PaymentFlag =="Y" && this.data.AdmCatID==3) {
          this.HelperService.showWarningMessage("You have already Applied & Paid for this Course.");
          return
        }
  } 
  onEditorPreparing(event: any) {
    debugger;
    if (event.parentType === "dataRow" && event.row.rowType === "data" && event.dataField === 'chk')  
     {  
      if ((event.row.data.ScheduleFlag === "N")) 
      {  
        event.editorOptions.disabled = true;
        event.editorOptions.readOnly = true;  
      }  
      if ((event.row.data.PaymentFlag === "Y")) 
       {  
        event.editorOptions.chk = true;
        event.editorOptions.disabled = true;
        event.editorOptions.readOnly = true;  
      } 
    }  
  }
  onSuccessSave() {
  }
  getParentApi(): ParentComponentApi {
    return {
      callParentMethod: (type,i) => {
        if(type==1)
        this.nextTab(i);
        else if(type==3)
        this.saveChangeTab(i);
        else
        this.backTab(i);
  
      } 
    }
  }
  saveChangeTab(i){
    
  }
}
export interface ParentComponentApi {
  callParentMethod: (id,string) => void
}
